module.exports = __webpack_public_path__ + "static/media/brectanova1.39f0588a.jpg";